import { render, staticRenderFns } from "./TitleResourceCreateComponent.vue?vue&type=template&id=76317ac4&"
import script from "./TitleResourceCreateComponent.vue?vue&type=script&lang=js&"
export * from "./TitleResourceCreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports